import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/liquidaciones';
import BonificacionesClass from './BonificacionesClass';
import './Bonificaciones.css';


const ms2p = (state) => {
    return {
        ...state.liquidaciones,
        proveedor: state.login.proveedor,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(BonificacionesClass);
